@if (data) {
  <div
    class="cutoff"
    [class.transparent-background]="transparentBackground"
    >
    <app-grid>
      <app-cell laptop="3:full"
        desktop="3:full"
                  [responsiveStyle$]="{
            mobile: {
                display: 'none'
            },
            tablet: {
                display: 'none'
            }
        } | responsiveStyle$">
      <div class="bar"></div>
    </app-cell>
    <app-cell mobile="full:0"
      tablet="full:0"
                  [responsiveStyle$]="{
            laptop: {
                display: 'none'
            },
            desktop: {
                display: 'none'
            }
        } | responsiveStyle$">
    <div class="gutter"></div>
  </app-cell>
  <app-cell desktop="0:5" laptop="0:5" tablet="0:12" mobile="0:12">
    <div class="big-image">
      @if (data.mainImage) {
        <app-responsive-image
          [image]="data.mainImage"
          [lazyLoad]="lazyLoad"
        ></app-responsive-image>
      }
    </div>
  </app-cell>
  <app-cell mobile="12:full"
                  [responsiveStyle$]="{
            laptop: {
                display: 'none'
            },
            desktop: {
                display: 'none'
            }
        } | responsiveStyle$">
  <div class="gutter"></div>
</app-cell>
<app-cell mobile="full:0"
  tablet="full:0"
                  [responsiveStyle$]="{
            laptop: {
                display: 'none'
            },
            desktop: {
                display: 'none'
            }
        } | responsiveStyle$">
<div class="gutter"></div>
</app-cell>
<app-cell desktop="5:12" laptop="5:12" tablet="0:12" mobile="0:12">
  <div class="content-container">
    <div>
      <h3 class="subheading serif">
        {{ data.subtitle }}
      </h3>
      <h1>
        {{ data.title }}
      </h1>
      <div class="body">
        <p class="summary">
          {{ data.text }}
        </p>
        <div class="buttons">
          @for (link of data.pageLinks; track link) {
            <div>
              <app-chevron-link [link]="link.link"
                [target]="link.target"
                >
                {{ link.label }}
              </app-chevron-link>
            </div>
          }
        </div>
      </div>
      <div class="images">
        @if (data.contentImage?.length) {
          @for (contentImage of data.contentImage; track contentImage) {
            <div
              class="image"
              >
              <app-responsive-image [image]="contentImage"
                [lazyLoad]="lazyLoad"
              ></app-responsive-image>
            </div>
          }
        } @else {
          <div class="image empty"></div>
        }
      </div>
    </div>
  </div>
</app-cell>
<app-cell mobile="12:full">
  <div class="gutter"></div>
</app-cell>
<app-cell laptop="3:full"
  desktop="3:full"
                  [responsiveStyle$]="{
            mobile: {
                display: 'none'
            },
            tablet: {
                display: 'none'
            }
        } | responsiveStyle$">
<div class="bar bottom"></div>
</app-cell>
</app-grid>
</div>
}
